import * as types from './mutations_types.js'

export const state = {
  userId: '',
  userName: '',
  userEmail: '',
  userPhone: '',
  userCounty: '',
  userDistrict: '',
  userAddress: '',
  userCash: 0,
  userValid: 0,
  userStock: 0,
  firstbuy: 1,
  token: '',
  apiurl: 'https://affiliate.i80.com.tw/api/v1',
  memberurl: 'https://affiliate.i80.com.tw/api/m1',
  authenticated: false,
  news: [],
  slide: {},
  companies: {},
  county: [
    { text: '請選擇', value: 0 }, { text: '基隆市', value: 1 }, { text: '台北市', value: 2 }, { text: '新北市', value: 3 },
    { text: '桃園市', value: 4 }, { text: '新竹市', value: 5 }, { text: '新竹縣', value: 6 },
    { text: '苗栗縣', value: 7 }, { text: '台中市', value: 8 }, { text: '彰化縣', value: 9 },
    { text: '南投縣', value: 10 }, { text: '雲林縣', value: 11 }, { text: '嘉義市', value: 12 },
    { text: '嘉義縣', value: 13 }, { text: '台南市', value: 14 }, { text: '高雄市', value: 15 },
    { text: '屏東縣', value: 16 }, { text: '台東縣', value: 17 }, { text: '花蓮縣', value: 18 },
    { text: '宜蘭縣', value: 19 }, { text: '澎湖縣', value: 20 }, { text: '金門縣', value: 21 }, { text: '連江縣', value: 22 }
  ],
  district: [
    [
      { text: '請選擇', value: 0 }, { text: '仁愛區', value: 1 }, { text: '信義區', value: 2 }, { text: '中正區', value: 3 },
      { text: '中山區', value: 4 }, { text: '安樂區', value: 5 }, { text: '暖暖區', value: 6 }, { text: '七堵區', value: 7 }
    ],
    [
      { text: '請選擇', value: 0 }, { text: '中正區', value: 1 }, { text: '大同區', value: 2 }, { text: '中山區', value: 3 },
      { text: '松山區', value: 4 }, { text: '大安區', value: 5 }, { text: '萬華區', value: 6 },
      { text: '信義區', value: 7 }, { text: '士林區', value: 8 }, { text: '北投區', value: 9 }, { text: '內湖區', value: 10 },
      { text: '南港區', value: 11 }, { text: '文山區', value: 12 }
    ],
    [
      { text: '請選擇', value: 0 }, { text: '萬里區', value: 1 }, { text: '金山區', value: 2 }, { text: '板橋區', value: 3 }, { text: '汐止區', value: 4 },
      { text: '深坑區', value: 5 }, { text: '石碇區', value: 6 }, { text: '瑞芳區', value: 7 }, { text: '平溪區', value: 8 },
      { text: '雙溪區', value: 9 }, { text: '貢寮區', value: 10 }, { text: '新店區', value: 11 }, { text: '坪林區', value: 12 },
      { text: '烏來區', value: 13 }, { text: '永和區', value: 14 }, { text: '中和區', value: 15 }, { text: '土城區', value: 16 },
      { text: '三峽區', value: 17 }, { text: '樹林區', value: 18 }, { text: '鶯歌區', value: 19 }, { text: '三重區', value: 20 },
      { text: '新莊區', value: 21 }, { text: '泰山區', value: 22 }, { text: '林口區', value: 23 }, { text: '蘆洲區', value: 24 },
      { text: '五股區', value: 25 }, { text: '八里區', value: 26 }, { text: '淡水區', value: 27 }, { text: '三芝區', value: 28 },
      { text: '石門區', value: 29 }
    ],
    [
      { text: '請選擇', value: 0 }, { text: '中壢區', value: 1 }, { text: '平鎮區', value: 2 }, { text: '龍潭區', value: 3 },
      { text: '楊梅區', value: 4 }, { text: '新屋區', value: 5 }, { text: '觀音區', value: 6 },
      { text: '桃園區', value: 7 }, { text: '龜山區', value: 8 }, { text: '八德區', value: 9 },
      { text: '大溪區', value: 10 }, { text: '復興區', value: 11 }, { text: '大園區', value: 12 }, { text: '蘆竹區', value: 13 }
    ],
    [
      { text: '請選擇', value: 0 }, { text: '東區', value: 1 }, { text: '北區', value: 2 }, { text: '香山區', value: 3 }
    ],
    [
      { text: '請選擇', value: 0 }, { text: '竹北市', value: 1 }, { text: '湖口鄉', value: 2 }, { text: '新豐鄉', value: 3 }, { text: '新埔鎮', value: 4 },
      { text: '關西鎮', value: 5 }, { text: '芎林鄉', value: 6 }, { text: '寶山鄉', value: 7 }, { text: '竹東鎮', value: 8 },
      { text: '五峰鄉', value: 9 }, { text: '橫山鄉', value: 10 }, { text: '尖石鄉', value: 11 }, { text: '北埔鄉', value: 12 },
      { text: '峨眉鄉', value: 13 }
    ],
    [
      { text: '請選擇', value: 0 }, { text: '竹南鎮', value: 1 }, { text: '頭份鎮', value: 2 }, { text: '三灣鄉', value: 3 }, { text: '南庄鄉', value: 4 },
      { text: '獅潭鄉', value: 5 }, { text: '後龍鎮', value: 6 }, { text: '通霄鎮', value: 7 }, { text: '苑裡鎮', value: 8 },
      { text: '苗栗市', value: 9 }, { text: '造橋鄉', value: 10 }, { text: '公館鄉', value: 11 }, { text: '泰安鄉', value: 12 },
      { text: '銅鑼鄉', value: 13 }, { text: '三義鄉', value: 14 }, { text: '西湖鄉', value: 15 }, { text: '卓蘭鎮', value: 16 }, { text: '大湖鄉', value: 17 }
    ],
    [
      { text: '請選擇', value: 0 }, { text: '中區', value: 1 }, { text: '東區', value: 2 }, { text: '南區', value: 3 }, { text: '西區', value: 4 },
      { text: '北區', value: 5 }, { text: '北屯區', value: 6 }, { text: '西屯區', value: 7 }, { text: '南屯區', value: 8 },
      { text: '太平區', value: 9 }, { text: '大里區', value: 10 }, { text: '霧峰區', value: 11 }, { text: '烏日區', value: 12 },
      { text: '豐原區', value: 13 }, { text: '后里區', value: 14 }, { text: '石岡區', value: 15 }, { text: '東勢區', value: 16 },
      { text: '和平區', value: 17 }, { text: '新社區', value: 18 }, { text: '潭子區', value: 19 }, { text: '大雅區', value: 20 },
      { text: '神岡區', value: 21 }, { text: '大肚區', value: 22 }, { text: '沙鹿區', value: 23 }, { text: '龍井區', value: 24 },
      { text: '梧棲區', value: 25 }, { text: '清水區', value: 26 }, { text: '大甲區', value: 27 }, { text: '外埔區', value: 28 },
      { text: '大安區', value: 29 }
    ],
    [
      { text: '請選擇', value: 0 }, { text: '彰化市', value: 1 }, { text: '芬園鄉', value: 2 }, { text: '花壇鄉', value: 3 }, { text: '秀水鄉', value: 4 },
      { text: '鹿港鎮', value: 5 }, { text: '福興鄉', value: 6 }, { text: '線西鄉', value: 7 }, { text: '和美鎮', value: 8 },
      { text: '伸港鄉', value: 9 }, { text: '員林鄉', value: 10 }, { text: '永靖鄉', value: 11 }, { text: '埔心鄉', value: 12 },
      { text: '溪湖鎮', value: 13 }, { text: '大村鄉', value: 14 }, { text: '埔鹽鄉', value: 15 }, { text: '田中鎮', value: 16 },
      { text: '北斗鎮', value: 17 }, { text: '田尾鄉', value: 18 }, { text: '埤頭鄉', value: 19 }, { text: '溪州鄉', value: 20 },
      { text: '竹塘鄉', value: 21 }, { text: '二林鎮', value: 22 }, { text: '大城鄉', value: 23 }, { text: '芳苑鄉', value: 24 },
      { text: '二水鄉', value: 25 }, { text: '社頭鄉', value: 26 }
    ],
    [
      { text: '請選擇', value: 0 }, { text: '南投市', value: 1 }, { text: '中寮鄉', value: 2 }, { text: '草屯鎮', value: 3 }, { text: '國姓鄉', value: 4 },
      { text: '埔里鎮', value: 5 }, { text: '仁愛鄉', value: 6 }, { text: '名間鄉', value: 7 }, { text: '集集鎮', value: 8 },
      { text: '水里鄉', value: 9 }, { text: '魚池鄉', value: 10 }, { text: '信義鄉', value: 11 }, { text: '竹山鎮', value: 12 },
      { text: '鹿谷鄉', value: 13 }
    ],
    [
      { text: '請選擇', value: 0 }, { text: '斗南鎮', value: 1 }, { text: '大埤鄉', value: 2 }, { text: '虎尾鎮', value: 3 }, { text: '土庫鎮', value: 4 },
      { text: '褒忠鄉', value: 5 }, { text: '東勢鄉', value: 6 }, { text: '台西鄉', value: 7 }, { text: '崙背鄉', value: 8 },
      { text: '麥寮鄉', value: 9 }, { text: '斗六市', value: 10 }, { text: '林內鄉', value: 11 }, { text: '古坑鄉', value: 12 },
      { text: '莿桐鄉', value: 13 }, { text: '西螺鎮', value: 14 }, { text: '二崙鄉', value: 15 }, { text: '北港鎮', value: 16 },
      { text: '水林鄉', value: 17 }, { text: '口湖鄉', value: 18 }, { text: '四湖鄉', value: 19 }, { text: '元長鄉', value: 20 }
    ],
    [
      { text: '請選擇', value: 0 }, { text: '東區', value: 1 }, { text: '西區', value: 2 }
    ],
    [
      { text: '請選擇', value: 0 }, { text: '番路鄉', value: 1 }, { text: '梅山鄉', value: 2 }, { text: '竹崎鄉', value: 3 }, { text: '阿里山鄉', value: 4 },
      { text: '中埔鄉', value: 5 }, { text: '大埔鄉', value: 6 }, { text: '水上鄉', value: 7 }, { text: '鹿草鄉', value: 8 },
      { text: '太保市', value: 9 }, { text: '朴子市', value: 10 }, { text: '東石鄉', value: 11 }, { text: '六腳鄉', value: 12 },
      { text: '新港鄉', value: 13 }, { text: '民雄鄉', value: 14 }, { text: '大林鎮', value: 15 }, { text: '溪口鄉', value: 16 },
      { text: '義竹鄉', value: 17 }, { text: '布袋鎮', value: 18 }
    ],
    [
      { text: '請選擇', value: 0 }, { text: '中西區', value: 1 }, { text: '東區', value: 2 }, { text: '南區', value: 3 }, { text: '北區', value: 4 },
      { text: '安平區', value: 5 }, { text: '安南區', value: 6 }, { text: '永康區', value: 7 }, { text: '歸仁區', value: 8 },
      { text: '新化區', value: 9 }, { text: '左鎮區', value: 10 }, { text: '玉井區', value: 11 }, { text: '楠西區', value: 12 },
      { text: '南化區', value: 13 }, { text: '仁德區', value: 14 }, { text: '關廟區', value: 15 }, { text: '龍崎嶇', value: 16 },
      { text: '官田區', value: 17 }, { text: '麻豆區', value: 18 }, { text: '佳里區', value: 19 }, { text: '西港區', value: 20 },
      { text: '七股區', value: 21 }, { text: '將軍區', value: 22 }, { text: '學甲區', value: 23 }, { text: '北門區', value: 24 },
      { text: '新營區', value: 25 }, { text: '後壁區', value: 26 }, { text: '白河區', value: 27 }, { text: '東山區', value: 28 },
      { text: '六甲區', value: 29 }, { text: '下營區', value: 30 }, { text: '柳營區', value: 31 }, { text: '鹽水區', value: 32 },
      { text: '善化區', value: 33 }, { text: '大內區', value: 34 }, { text: '山上區', value: 35 }, { text: '新市區', value: 36 },
      { text: '安定區', value: 37 }
    ],
    [
      { text: '請選擇', value: 0 }, { text: '新興區', value: 1 }, { text: '前金區', value: 2 }, { text: '苓雅區', value: 3 }, { text: '鹽埕區', value: 4 },
      { text: '鼓山區', value: 5 }, { text: '旗津區', value: 6 }, { text: '前鎮區', value: 7 }, { text: '三民區', value: 8 },
      { text: '楠梓區', value: 9 }, { text: '小港區', value: 10 }, { text: '左營區', value: 11 }, { text: '仁武區', value: 12 },
      { text: '大社區', value: 13 }, { text: '東沙群島', value: 14 }, { text: '南沙群島', value: 15 }, { text: '岡山區', value: 16 },
      { text: '路竹區', value: 17 }, { text: '阿蓮區', value: 18 }, { text: '田寮區', value: 19 }, { text: '燕巢區', value: 20 },
      { text: '橋頭區', value: 21 }, { text: '梓官區', value: 22 }, { text: '彌陀區', value: 23 }, { text: '永安區', value: 24 },
      { text: '湖內區', value: 25 }, { text: '鳳山區', value: 26 }, { text: '大寮區', value: 27 }, { text: '林園區', value: 28 },
      { text: '六甲區', value: 29 }, { text: '下營區', value: 30 }, { text: '柳營區', value: 31 }, { text: '鹽水區', value: 32 },
      { text: '烏林區', value: 33 }, { text: '大樹區', value: 34 }, { text: '旗山區', value: 35 }, { text: '美濃區', value: 36 },
      { text: '六龜區', value: 37 }, { text: '內門區', value: 38 }, { text: '杉林區', value: 39 }, { text: '甲仙區', value: 40 },
      { text: '桃源區', value: 41 }, { text: '那瑪夏區', value: 42 }, { text: '茂林區', value: 43 }, { text: '茄萣區', value: 44 }, { text: '鳥松區', value: 45 }
    ],
    [
      { text: '請選擇', value: 0 }, { text: '屏東市', value: 1 }, { text: '三地門鄉', value: 2 }, { text: '霧台鄉', value: 3 }, { text: '瑪家鄉', value: 4 },
      { text: '九如鄉', value: 5 }, { text: '里港鄉', value: 6 }, { text: '高樹鄉', value: 7 }, { text: '鹽埔鄉', value: 8 },
      { text: '長治鄉', value: 9 }, { text: '麟洛鄉', value: 10 }, { text: '竹田鄉', value: 11 }, { text: '內埔鄉', value: 12 },
      { text: '萬丹鄉', value: 13 }, { text: '潮州鎮', value: 14 }, { text: '泰武鄉', value: 15 }, { text: '來義鄉', value: 16 },
      { text: '萬巒鄉', value: 17 }, { text: '崁頂鄉', value: 18 }, { text: '新埤鄉', value: 16 }, { text: '南州鄉', value: 20 },
      { text: '林邊鄉', value: 21 }, { text: '東港鎮', value: 22 }, { text: '琉球鄉', value: 23 }, { text: '佳冬鄉', value: 24 },
      { text: '新園鄉', value: 25 }, { text: '枋寮鄉', value: 26 }, { text: '枋山鄉', value: 27 }, { text: '春日鄉', value: 28 },
      { text: '獅子鄉', value: 29 }, { text: '車城鄉', value: 30 }, { text: '牡丹鄉', value: 31 }, { text: '恆春鎮', value: 32 },
      { text: '滿州鄉', value: 33 }
    ],
    [
      { text: '請選擇', value: 0 }, { text: '台東市', value: 1 }, { text: '綠島鄉', value: 2 }, { text: '蘭嶼鄉', value: 3 }, { text: '延平鄉', value: 4 },
      { text: '卑南鄉', value: 5 }, { text: '鹿野鄉', value: 6 }, { text: '關山鎮', value: 7 }, { text: '海端鄉', value: 8 },
      { text: '池上鄉', value: 9 }, { text: '東河鄉', value: 10 }, { text: '成功鎮', value: 11 }, { text: '長濱鄉', value: 12 },
      { text: '太麻里鄉', value: 13 }, { text: '金峰鄉', value: 14 }, { text: '大武鄉', value: 15 }, { text: '達仁鄉', value: 16 }
    ],
    [
      { text: '請選擇', value: 0 }, { text: '花蓮市', value: 1 }, { text: '新城鄉', value: 2 }, { text: '秀林鄉', value: 3 }, { text: '吉安鄉', value: 4 },
      { text: '壽豐鄉', value: 5 }, { text: '鳳林鄉', value: 6 }, { text: '光復鄉', value: 7 }, { text: '豐濱鄉', value: 8 },
      { text: '瑞穗鄉', value: 9 }, { text: '萬榮鄉', value: 10 }, { text: '玉里鎮', value: 11 }, { text: '卓溪鄉', value: 12 }, { text: '富里鄉', value: 13 }
    ],
    [
      { text: '請選擇', value: 0 }, { text: '宜蘭市', value: 1 }, { text: '頭城鎮', value: 2 }, { text: '礁溪鄉', value: 3 }, { text: '壯圍鄉', value: 4 },
      { text: '員山鄉', value: 5 }, { text: '羅東鎮', value: 6 }, { text: '三星鄉', value: 7 }, { text: '大同鄉', value: 8 },
      { text: '五結鄉', value: 9 }, { text: '冬山鄉', value: 10 }, { text: '蘇澳鄉', value: 11 }, { text: '釣魚台', value: 12 }
    ],
    [
      { text: '請選擇', value: 0 }, { text: '馬公市', value: 1 }, { text: '西嶼鄉', value: 2 }, { text: '望安鄉', value: 3 },
      { text: '七美鄉', value: 4 }, { text: '白沙鄉', value: 5 }, { text: '湖西鄉', value: 6 }
    ],
    [
      { text: '請選擇', value: 0 }, { text: '金沙鎮', value: 1 }, { text: '金湖鎮', value: 2 }, { text: '金寧鄉', value: 3 },
      { text: '金城鎮', value: 4 }, { text: '烈嶼鄉', value: 5 }, { text: '烏坵鄉', value: 6 }
    ],
    [
      { text: '請選擇', value: 0 }, { text: '南竿鄉', value: 1 }, { text: '北竿鄉', value: 2 }, { text: '莒光鄉', value: 3 },
      { text: '東引鄉', value: 4 }
    ]
  ]
}

export const mutations = {
  [types.SET_TOKEN] (state, token) {
    state.token = token
  },
  [types.LOGOUT] () {
    localStorage.removeItem('cart')
    localStorage.removeItem('userId')
    localStorage.removeItem('shareid')
    localStorage.removeItem('userName')
    localStorage.removeItem('userEmail')
    localStorage.removeItem('userAddress')
    localStorage.removeItem('userCounty')
    localStorage.removeItem('userDistrict')
    localStorage.removeItem('userCash')
    localStorage.removeItem('userValid')
    localStorage.removeItem('userPhone')
    localStorage.removeItem('userStock')
    localStorage.removeItem('token')
    localStorage.removeItem('firstbuy')
    state.authenticated = false
    state.userId = ''
    state.userName = ''
    state.token = ''
    state.userValid = ''
    state.firstbuy = 1
  },
  [types.CLEAR_FIRST_BUY] () {
    state.firstbuy = 1
  },
  [types.UPDATEUSER] (state, creds) {
    let data = creds.data
    if (localStorage) {
      state.userName = data.userName
      state.userPhone = data.userPhone
      localStorage.setItem('userName', data.userName)
      localStorage.setItem('userPhone', data.userPhone)
    }
  },
  [types.LOGIN] (state, creds) {
    state.authenticated = true
    let data = creds.data
    if (localStorage) {
      state.userId = data.userId
      state.userName = data.userName
      state.token = data.token
      state.userEmail = data.userEmail
      state.userPhone = data.userPhone
      state.userCounty = data.userCounty
      state.userDistrict = data.userDistrict
      state.userAddress = data.userAddress
      state.userCash = data.userCash
      state.volunteer_quota = data.volunteer_quota
      state.userValid = data.userValid
      state.userStock = data.userStock
      state.firstbuy = parseInt(data.firstbuy)
      localStorage.setItem('userId', data.userId)
      localStorage.setItem('shareid', data.userId)
      localStorage.setItem('userName', data.userName)
      localStorage.setItem('token', data.token)
      localStorage.setItem('userEmail', data.userEmail)
      localStorage.setItem('userPhone', data.userPhone)
      localStorage.setItem('userCounty', data.userCounty)
      localStorage.setItem('userDistrict', data.userDistrict)
      localStorage.setItem('userAddress', data.userAddress)
      localStorage.setItem('userCash', data.userCash)
      localStorage.setItem('volunteer_quota', data.volunteer_quota)
      localStorage.setItem('userValid', data.userValid)
      localStorage.setItem('userStock', data.userStock)
      localStorage.setItem('firstbuy', data.firstbuy)
    }
  },
  [types.SET_NEWS] (state, data) {
    state.news = data
    localStorage.setItem('news', JSON.stringify(data))
  },
  [types.SET_COMPANIES] (state, data) {
    state.companies = data
    localStorage.setItem('companies', JSON.stringify(data))
  },
  [types.SET_SLIDE] (state, data) {
    state.slide = data
    localStorage.setItem('slide', data)
  },
  check () {
    let jwt = localStorage.getItem('token')
    if (jwt) {
      state.authenticated = true
    } else {
      state.authenticated = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/home/mutations.js